// Mock data for Luxury Puppies Kennel Benidorm

export const BREEDS = [
  { id: 'pomerania', name: 'Pomerania', icon: '🦊' },
  { id: 'maltipoo', name: 'Maltipoo', icon: '🐩' },
  { id: 'caniche', name: 'Caniche', icon: '🐕' },
  { id: 'caniche-asiatico', name: 'Caniche Asiático', icon: '🐕' },
  { id: 'shih-tzu', name: 'Shih-Tzu', icon: '🐶' },
  { id: 'bichon-maltes', name: 'Bichón Maltés', icon: '🐾' },
  { id: 'teckel', name: 'Teckel', icon: '🌭' },
  { id: 'pomsky', name: 'Pomsky', icon: '🐺' },
  { id: 'yorkshire', name: 'Yorkshire Terrier', icon: '🎀' },
  { id: 'pekines', name: 'Pekinés', icon: '🦁' },
  { id: 'pekines-imperial', name: 'Pekinés Imperial', icon: '👑' },
  { id: 'chihuahua', name: 'Chihuahua', icon: '🐕‍🦺' },
  { id: 'spitz-klein', name: 'Spitz Klein', icon: '🐾' },
  { id: 'shihpoo', name: 'Shihpoo', icon: '🐩' },
  { id: 'pomapoo', name: 'Pomapoo', icon: '🦊' },
  { id: 'crestado-chino', name: 'Crestado Chino', icon: '🐕' },
  { id: 'cesion-adulto', name: 'Programa de retiro - Ejemplar de élite', icon: '⭐' },
  { id: 'adopcion-responsable', name: 'Adopción responsable', icon: '🐾' },
  { id: 'otras-razas', name: 'Otras razas - Te busco el cachorro de tus sueños🐶', icon: '✨' }
];

export const COLORS = [
  'Blanco',
  'Negro',
  'Crema',
  'Marrón',
  'Naranja',
  'Gris',
  'Parti-color',
  'Sable',
  'Chocolate',
  'Champagne',
  'Apricot',
  'Rojo',
  'Canela',
  'Tricolor',
  'Merle',
  'Husky',
  'Agouti'
];

export const mockPuppies = [
  {
    id: '1',
    name: 'Luna',
    breed: 'pomerania',
    color: 'Naranja',
    sex: 'Hembra',
    adultWeight: '2-3 kg',
    price: 1800,
    status: 'disponible',
    image: 'https://images.unsplash.com/photo-1587300003388-59208cc962cb?w=400',
    birthDate: '2025-06-15',
    description: 'Pequeña princesa muy juguetona y cariñosa'
  },
  {
    id: '2',
    name: 'Max',
    breed: 'pomerania',
    color: 'Crema',
    sex: 'Macho',
    adultWeight: '2.5-3.5 kg',
    price: 1600,
    status: 'reservado',
    image: 'https://images.unsplash.com/photo-1605897472359-85e4b94d685d?w=400',
    birthDate: '2025-05-20',
    description: 'Cachorro muy activo y sociable'
  },
  {
    id: '3',
    name: 'Coco',
    breed: 'maltipoo',
    color: 'Blanco',
    sex: 'Hembra',
    adultWeight: '3-4 kg',
    price: 2000,
    status: 'disponible',
    image: 'https://images.unsplash.com/photo-1583511655857-d19b40a7a54e?w=400',
    birthDate: '2025-07-01',
    description: 'Maltipoo de pelaje sedoso, hipoalergénica'
  },
  {
    id: '4',
    name: 'Toby',
    breed: 'caniche',
    color: 'Chocolate',
    sex: 'Macho',
    adultWeight: '4-5 kg',
    price: 1400,
    status: 'disponible',
    image: 'https://images.unsplash.com/photo-1594149929911-78975a43d4f5?w=400',
    birthDate: '2025-06-10',
    description: 'Caniche toy muy inteligente y fácil de entrenar'
  },
  {
    id: '5',
    name: 'Mia',
    breed: 'shih-tzu',
    color: 'Parti-color',
    sex: 'Hembra',
    adultWeight: '4-7 kg',
    price: 1500,
    status: 'disponible',
    image: 'https://images.unsplash.com/photo-1586671267731-da2cf3ceeb80?w=400',
    birthDate: '2025-05-25',
    description: 'Shih-Tzu con hermoso pelaje bicolor'
  },
  {
    id: '6',
    name: 'Bella',
    breed: 'bichon-maltes',
    color: 'Blanco',
    sex: 'Hembra',
    adultWeight: '3-4 kg',
    price: 1700,
    status: 'reservado',
    image: 'https://images.unsplash.com/photo-1587300003388-59208cc962cb?w=400',
    birthDate: '2025-06-28',
    description: 'Bichón Maltés puro, pelaje de algodón'
  },
  {
    id: '7',
    name: 'Salchicha',
    breed: 'teckel',
    color: 'Marrón',
    sex: 'Macho',
    adultWeight: '7-12 kg',
    price: 1300,
    status: 'disponible',
    image: 'https://images.unsplash.com/photo-1612195583950-b8fd34c87093?w=400',
    birthDate: '2025-06-05',
    description: 'Teckel de pelo corto, muy juguetón y cariñoso'
  },
  {
    id: '8',
    name: 'Nieve',
    breed: 'pomsky',
    color: 'Gris',
    sex: 'Hembra',
    adultWeight: '9-14 kg',
    price: 2500,
    status: 'disponible',
    image: 'https://images.unsplash.com/photo-1553882809-a4f57e59501d?w=400',
    birthDate: '2025-07-10',
    description: 'Pomsky con hermosos ojos azules, mezcla perfecta de Pomerania y Husky'
  },
  {
    id: '9',
    name: 'Chiqui',
    breed: 'yorkshire',
    color: 'Negro',
    sex: 'Hembra',
    adultWeight: '2-3.5 kg',
    price: 1400,
    status: 'disponible',
    image: 'https://images.unsplash.com/photo-1583337130417-3346a1be7dee?w=400',
    birthDate: '2025-05-30',
    description: 'Yorkshire Terrier miniatura, pelaje sedoso y brillante'
  }
];

export const BUSINESS_INFO = {
  name: 'Luxury Puppies Kennel Benidorm',
  whatsapp: '604370339',
  logo: 'https://customer-assets.emergentagent.com/job_9f8081e7-ef27-4fe5-8ac6-0c626eaf41c5/artifacts/no0hu4xv_604-370-339_20251105_175033_0000.png'
};
